// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"87":"select2","188":"daterangepicker","247":"matchheight","561":"inspiration"}[chunkId] || chunkId) + ".min.js";
};